// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_SubscriptionRow.php
// Do not edit by hand — edit the PHP RowContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_SubscriptionRow — one row for GET /subscriptions/mine.
 *
 * Covers ALL statuses (live + terminal history). franchise_name is injected
 * by the controller (not stored in franchises_subscriptions). Datetime fields
 * are ISO-8601 UTC strings (controller converts GMT-3 before fromRows()).
 * subscription_id and status are null when the franchise has no subscription.
 */
import { registerContract } from './validate'

export interface Subscriptions_SubscriptionRow {
franchise_id: number
subscription_id?: number
franchise_name?: string
plan_name?: string
provider?: string
currency?: string
price_cents?: number
status?: string
exempt?: number
grace_until?: string
grace_ends_at?: string
grace_days_remaining?: number
paid_through?: string
current_period_start?: string
current_period_end?: string
created_at?: string
setup_status?: string
has_pending_setup_fee?: boolean
credits_balance_micro?: number
setup_fee_amount_cents?: number
setup_fee_currency?: string
}

registerContract('Subscriptions_SubscriptionRow', {
  franchise_id:           { type: 'number',  required: true },
  subscription_id:        { type: 'number',  required: false },
  franchise_name:         { type: 'string',  required: false },
  plan_name:              { type: 'string',  required: false },
  provider:               { type: 'string',  required: false },
  currency:               { type: 'string',  required: false },
  price_cents:            { type: 'number',  required: false },
  status:                 { type: 'string',  required: false },
  exempt:                 { type: 'number',  required: false },
  grace_until:            { type: 'string',  required: false },
  grace_ends_at:          { type: 'string',  required: false },
  grace_days_remaining:   { type: 'number',  required: false },
  paid_through:           { type: 'string',  required: false },
  current_period_start:   { type: 'string',  required: false },
  current_period_end:     { type: 'string',  required: false },
  created_at:             { type: 'string',  required: false },
  setup_status:           { type: 'string',  required: false },
  has_pending_setup_fee:  { type: 'boolean', required: false },
  credits_balance_micro:  { type: 'number',  required: false },
  setup_fee_amount_cents: { type: 'number',  required: false },
  setup_fee_currency:     { type: 'string',  required: false },
})
